export default __webpack_public_path__ + "static/media/source.25330ea9.svg";